import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

//STYLES
import './TaskDetails.css'

//COMPONENTS
import ParagaphsParser from '../../../components/misc/ParagaphsParser'
import Button from '../../../components/ui/Button'

export default function TaskDetail( {tasks, setTasks}) {

  const { id } = useParams()
  const nav = useNavigate()
  
  const [task, setTask] = useState(null)

  useEffect( () => {
    if (tasks) {
      setTask( tasks.find( (t) => t.id === id))
    }
  },[tasks, id])
  
  const paragraphs = task?.contentBlocks?.map( (p, index) => {
    return {...p, attr:{...p.attr, key: index}}
  })

  const goBack = () => {
    nav('/bar/cat/' + task.catId)
  }

  const markCompleteAndGoBack = () => {
    setTasks( tasks.map( (t) => {
      if (t.id === id) {
        return {...t, completed: true}
      } else {
        return t
      }
    }))
    goBack()
  }

  return (
    <div className='page-container shadowed'>
      { task && (
        <>
          <div>
            <Button
              icon="BACK"
              clickFunction={goBack}
              isInverted
              text="BACK"
            />
          </div>
          <div className="details-container">
            <h2>{task?.title}</h2>
            {paragraphs && <ParagaphsParser paragraphs={paragraphs}/>}
            {
      
            !task?.completed && (<Button
              icon=''
              clickFunction={markCompleteAndGoBack}
              isOutlined
              isBlock
              text="Marquée comme terminée"
            />)
            }
          </div>
        </>
      )}
    </div>
  )
}
